import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { CREATE_ARTICLE_CATEGORY_MUTATION } from './createArticleCategory.mutation';
import {
  CreateArticleCategoryMutation,
  CreateArticleCategoryMutationVariables
} from './__generated__/CreateArticleCategoryMutation';

export const useCreateArticleCategory = () => {
  return useMutation<CreateArticleCategoryMutation, CreateArticleCategoryMutationVariables>(
    CREATE_ARTICLE_CATEGORY_MUTATION,
    { client: kmsClient }
  );
};
